<template>
  <div class="content">

    <div class="user-management">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <Card>
              <template slot="header">
                  <div class="header-container">
                <div class="dropdown-container">
                  <EmployeeDropdown
                    :employees="$store.state.auth.allUsers"
                    :company="$store.state.auth.company"
                    defaultFilter="active"
                    @update="filteredUsers = $event"
                  />

                      </div>
                <div class="button-container">
                    <!-- <input v-model="searchTerm" type="text" class="search-input"
                      placeholder="Search by name or email" /> -->
                    <button class="add-employee" @click="addEmp">Add Employee</button>
                </div>
              </div>
              </template>
              <div v-if="plan === 'free'" class="text-center py-5"
                style="display:flex; flex-direction: column; justify-content: center; align-items:center; height: 400px">
                <h3>Upgrade Your Plan!</h3>
                <p style="font-size: 20px">If you want to access these features, you have to upgrade your plan!</p>
              </div>
              <div v-else>
                <div v-if="loading" class="progress">
                  <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                    style="width: 100%"></div>
                </div>
                <CustomTable :columns="tableColumns" :data="filteredUsers">
                  <!-- Profile Picture -->
                  <template #profile_picture="{ item }">
                    <img style="width: 32px; height: 32px; border-radius: 20px; padding: 2px; border: 2px solid gray"
                      :src="item.profile_picture || 'static/img/default-dp.png'" alt="avatar"
                      @click="$router.replace(`/user/${item.uid}`)">
                  </template>

                  <!-- Basic Info -->
                  <template #username="{ item }">
                    <span class="truncate-text" :title="item.username">{{ item.username || '-' }}</span>
                  </template>

                  <template #designation="{ item }">
                    <span class="truncate-text" :title="item.designation">{{ item.designation || '-' }}</span>
                  </template>

                  <template #grade="{ item }">
                    <span class="truncate-text" :title="item.grade">{{ item.grade || '-' }}</span>
                  </template>
                  <!-- Joining Date -->
                  <template #joiningDate="{ item }">
                    <input
                      type="date"
                      v-model="item.joiningDate"
                      class="meeting-date-input"
                      @change="updateMeetingDate(item, 'joiningDate', item.joiningDate)"
                    />
                  </template>

                  <template #companyEmail="{ item }">
                    <span class="truncate-text" :title="item.companyEmail">{{ item.companyEmail || '-' }}</span>
                  </template>

                  <template #personalEmail="{ item }">
                    <span class="truncate-text" :title="item.personalEmail">{{ item.personalEmail || '-' }}</span>
                  </template>

                  <template #dateOfBirth="{ item }">
                    <span class="truncate-text" :title="item.dateOfBirth">{{ item.dateOfBirth || '-' }}</span>
                  </template>

                  <template #nationality="{ item }">
                    <span class="truncate-text" :title="item.nationality">{{ item.nationality || '-' }}</span>
                  </template>

                  <template #maritalStatus="{ item }">
                    <span class="truncate-text" :title="item.maritalStatus">{{ item.maritalStatus || '-' }}</span>
                  </template>

                  <template #currentAddress="{ item }">
                    <span class="truncate-text" :title="item.currentAddress">{{ item.currentAddress || '-' }}</span>
                  </template>

                  <template #permanentAddress="{ item }">
                    <span class="truncate-text" :title="item.permanentAddress">{{ item.permanentAddress || '-' }}</span>
                  </template>

                  <template #emergencyContactName="{ item }">
                    <span class="truncate-text" :title="item.emergencyContactName">{{ item.emergencyContactName || '-' }}</span>
                  </template>

                  <template #emergencyContactNumber="{ item }">
                    <span class="truncate-text" :title="item.emergencyContactNumber">{{ item.emergencyContactNumber ||
                      '-' }}</span>
                  </template>
                  <template #role="{ item }">
                  <div style="position:relative">
                    <div style="position:absolute; width: 140px; margin-top:2px;  margin-left:8px; height: 20px; display: flex; justify-content: center; align-items: center">
                      <CustomDropdown
                        v-if="isCurrentUserAdmin"
                        id="role"
                        :options="roleOptions"
                        :value="item.role"
                        :placeholder="'Select Role'"
                        :disabled="!isCurrentUserAdmin"
                        @change="changeRole($event, item)"
                        :height="'30px'"
                      />
                      <span v-else>{{ item.role || '-' }}</span>
                    </div>
                    </div>
                  </template>

                  <template #nicImageUrl="{ item }">
                    <span v-if="item.nicImageUrl" class="view-cnic">
                      <a :href="item.nicImageUrl" target="_blank">View CNIC</a>
                    </span>
                    <span v-else>-</span>
                  </template>

                  <template #certificateUrl="{ item }">
                    <span v-if="item.certificateUrl" class="view-letter">
                      <a :href="item.certificateUrl" target="_blank">View Letter</a>
                    </span>
                    <span v-else>-</span>
                  </template>

                  <template #salarySlipUrl="{ item }">
                    <span v-if="item.salarySlipUrl" class="view-slip">
                      <a :href="item.salarySlipUrl" target="_blank">View Slip</a>
                    </span>
                    <span v-else>-</span>
                  </template>

                  <template #active="{ item }">
                  <div style="position:relative">
                    <div style="position:absolute; margin-top:2px; width: 140px; margin-left:8px; height: 20px; display: flex; justify-content: center; align-items: center">
                      <CustomDropdown
                        v-if="isCurrentUserAdmin"
                        id="active"
                        :options="activeOptions"
                        :value="item.isActive ? 'Active' : 'InActive'"
                        :placeholder="'Select Status'"
                        :disabled="!isCurrentUserAdmin"
                        @change="changeStatus($event === 'Active', item)"
                        :height="'30px'"
                      />
                      <span v-else>{{ item.isActive ? 'Active' : 'InActive' }}</span>
                    </div>
                    </div>
                  </template>

                  <template #status="{ item }">
                    <div v-if="!item" style="color: red;">No item data</div>
                    <Status v-else :item="item" :isAdmin="isCurrentUserAdmin" displayMode="status" @status-change="openStatusChangeModal" />
                  </template>
                  <template #promotionInfo="{ item }">
                    <div class="promotion-info">
                      <!-- Toggle Button -->
                      <div v-if="item.promotionInfo && item.promotionInfo.length" class="promotion-header" @click="togglePromotions(item)">
                        <span v-if="!item.isPromotionExpanded">View Notes ({{ item.promotionInfo && item.promotionInfo.length || 0 }})</span>
                      </div>

                      <div v-if="!item.promotionInfo || !item.promotionInfo.length" class="add-note" @click="togglePromotions(item)">
                        <i class="fa fa-plus"></i> Add First Note
                      </div>
                    </div>
                  </template>
                  <!-- Next Quarterly Meeting -->
                  <template #nextQuarterlyMeeting="{ item }">
                    <div class="meeting-cell">
                      <template v-if="item.nextQuarterlyMeetingDetails ? item.nextQuarterlyMeetingDetails.date : item.nextQuarterlyMeeting">
                        <span class="icon-btn" @click="openMeetingModal(item, 'quarterly')" title="Edit meeting">
                          <i class="fa fa-edit"></i>
                        </span>
                        <span class="meeting-date">
                          {{ formatDate(item.nextQuarterlyMeetingDetails ? item.nextQuarterlyMeetingDetails.date : item.nextQuarterlyMeeting) || '-' }}
                        </span>
                      </template>

                      <span v-else class="schedule-meeting" @click="openMeetingModal(item, 'quarterly')">
                        <v-icon size="18">mdi-calendar</v-icon>
                        Schedule Meeting
                      </span>
                    </div>
                  </template>

                  <!-- Next Increment Review Meeting -->
                  <template #nextIncrementReview="{ item }">
                    <div class="meeting-cell">
                      <template v-if="item.nextIncrementMeetingDetails ? item.nextIncrementMeetingDetails.date : item.nextIncrementReview">
                        <span class="icon-btn" @click="openMeetingModal(item, 'increment')" title="Edit meeting">
                          <i class="fa fa-edit"></i>
                        </span>
                        <span class="meeting-date">
                          {{ formatDate(item.nextIncrementMeetingDetails ? item.nextIncrementMeetingDetails.date : item.nextIncrementReview) || '-' }}
                        </span>
                      </template>

                      <span v-else class="schedule-meeting" @click="openMeetingModal(item, 'increment')">
                        <v-icon size="18">mdi-calendar</v-icon>
                        Schedule Meeting
                      </span>
                    </div>
                  </template>


                  <template #resignationDate="{ item }">
                    <div v-if="!item" style="color: red;">No item data</div>
                    <Status v-else :item="item" :isAdmin="isCurrentUserAdmin" displayMode="resignationDate" />
                  </template>

                  <!-- Last Working Date -->
                  <template #lastWorkingDate="{ item }">
                    <input
                      v-if="item.status === 'Resigned'"
                      type="date"
                      v-model="item.lastWorkingDate"
                      class="meeting-date-input"
                      @change="updateMeetingDate(item, 'lastWorkingDate', item.lastWorkingDate)"
                    />
                    <span v-else>-</span>
                  </template>

                  <template #durationSpent="{ item }">
                    <span class="truncate-text">{{ calculateDuration(item) || '-' }}</span>
                  </template>
                  <!-- show shift in Capilize -->
                  <template #shift="{ item }">
                    <span class="truncate-text" :title="item.shift">{{ item.shift ? (item.shift.charAt(0).toUpperCase() + item.shift.slice(1)) : 'Morning' }}</span>
                  </template>

                  <template #action="{ item }">
                    <div class="action-buttons">
                      <div @click="$router.push(`/user/${item.uid}`)" class="edit-btn btn-status" title="Edit">
                        <PencilIcon color="gray" :width="16" :height="16" />
                      </div>
                     <div @click="loginAsEmployee(item)" class="login-btn btn-status" title="Login as Employee">
                        <i class="fa fa-sign-in-alt" style="color: gray;"></i>
                      </div>
                      <div @click="delEmp(item)" class="delete-btn btn-status" title="Delete">
                        <i class="fa fa-trash" style="color: gray;"></i>
                      </div>
                    </div>
                  </template>
                </CustomTable>

              </div>
            </Card>
          </div>
        </div>
      </div>
      <ReuseableModal :modelValue="isDeleteModalOpen" @update:modelValue="isDeleteModalOpen = $event"
        title="Confirm Deletion" submitButtonText="Delete" @submit="confirmDelete">
        <div>Are you sure you want to delete this user?</div>
      </ReuseableModal>
        <MeetingModal :modelValue="showModal" :meeting="selectedMeeting" :loading="loadings" :users="filteredUsers" :selectedEmployee="selectedUser" :meetingType="meetingType"  @save="saveMeeting"
        @delete="deleteMeeting" @update:modelValue="showModal = $event" />
      <ReuseableModal 
        :modelValue="isEmployeeModalOpen"  
        @update:modelValue="isEmployeeModalOpen = $event"
        title="Add Employee" 
        :isLarge="true"
        submitButtonText="Save" 
        @submit="addEmployee()"
        :loading="isLoading"
      >
        <form @submit.prevent="addEmployee()" style="padding: 10px 0px;">
          <div class="form-group row">
            <div class="col-md-6" style="margin-bottom: 7px;">
              <label for="name">Name <span style="color: red; font-size: 14px;">*</span></label>
              <input type="text" id="name" class="form-control" placeholder="Full Name" v-model="name" />
              <span v-if="nameError" class="text-danger">{{ nameError }}</span>
            </div>
            <div class="col-md-6">
              <label for="email">Email <span style="color: red; font-size: 14px;">*</span></label>
              <input type="email" id="email" class="form-control" placeholder="user@expertizo.pk" v-model="email" />
              <span v-if="emailError" class="text-danger">{{ emailError }}</span>
            </div>
          </div>
          <div class="form-group row">
              <div class="col-md-6">
                <label for="designation">Designation</label>
                <CustomDropdown id="designation" label="" :options="designations" :value="designation"
                placeholder="Select your designation" :show-error="false" @change="onDesignationChange" />
              </div>
              <div class="col-md-6">
                <label for="grade">Grade</label>
                <GradeDropdown id="grade" v-model="grade" :designation="designation" :designationGrades="designationGrades"
                  placeholder="Select Grade" :show-error="false" @change="onGradeChange" />
              </div>
           
          </div>
          <div class="form-group row" style="margin-top: -15px;">
            <div class="col-md-6">
              <label for="shift">Shift <span style="color: red; font-size: 14px;">*</span></label>
              <CustomDropdown 
                id="shift" 
                :options="shiftOptions" 
                :value="shift" 
                placeholder="Select Shift" 
                :show-error="!!shiftError" 
                @change="onShiftChange" 
              />
              <span v-if="shiftError" class="text-danger">{{ shiftError }}</span>
            </div>
          </div>

          <div class="form-group">
            <div class="checkbox-box" style="display: flex; align-items: center; margin-top: -15px;">
              <input type="checkbox" class="checkbox" style="width: 15px ; height: 15px; margin-top: 5px;" id="isAdmin"
                v-model="isAdmin" />
              <label style="width: max-content; margin-top:8px" for="isAdmin">Is Admin</label>
            </div>
          </div>
        </form>
      </ReuseableModal>
      <ReuseableModal
        :modelValue="isPromotionModalOpen"
        @update:modelValue="isPromotionModalOpen = $event"
        :title="promotionEditIndex !== null ? 'Edit Note' : 'Add Note'"
        submitButtonText="Save"
        @submit="savePromotion"
      >
        <div class="form-group">
          <label>Note</label>
          <textarea
            class="form-control"
            rows="4"
            v-model="promotionText"
            placeholder="e.g. Increased salary from Rs. 70,000 to Rs. 75,000 on 1st Sept 2025"
          ></textarea>
        </div>

        <div class="form-group mt-3">
          <label>
            <input type="checkbox" v-model="isSalaryPromotion" />
            This is a salary increment
          </label>
        </div>

        <div v-if="isSalaryPromotion" class="salary-fields mt-3">
          <label>New Basic Salary</label>
          <input type="number" class="form-control" v-model.number="newBasicSalary" placeholder="e.g. 75000" />

          <label class="mt-2">New Extra Allowance</label>
          <input type="number" class="form-control" v-model.number="newExtraAllowance" placeholder="e.g. 5000" />
        </div>
      </ReuseableModal>
      <ReuseableModal :modelValue="isStatusChangeModalOpen" @update:modelValue="isStatusChangeModalOpen = $event" 
        title="Send Employment Status Change Notification" :xlarge="true" :scrollable="true" submitButtonText="Send & Update Status"
        @submit="submitStatusChange" :loading="isSubmitting">
        <div style="display: flex; flex-direction: column; gap: 15px;">
          <div class="info-box">
            <div class="row">
              <div class="col-md-6">
                <strong>Employee:</strong> {{ selectedEmployee.username || '' }}
              </div>
              <div class="col-md-6">
                <strong>Old Employment Status:</strong> {{ oldStatus }}
              </div>
            </div>

            <div class="row mt-1">
              <div class="col-md-6">
                <strong>New Employment Status:</strong> {{ newStatus }}
              </div>
              <div v-if="(newStatus === 'Resigned') || (newStatus === 'Terminated')" class="col-md-6">
                <strong>Notice Period:</strong>
                <span v-if="newStatus === 'Resigned'">{{ noticePeriodDays() }} days</span>
                <span v-if="newStatus === 'Terminated'">Immediate (No Notice period)</span>
              </div>
            </div>
          </div>

          <div>
            <label>
              To <span class="text-danger">*</span>
            </label>

            <div class="user-pill">
              <img style="width: 36px; height: 36px; border-radius: 20px; padding: 2px; border: 2px solid gray" :src="selectedEmployee.profile_picture || 'static/img/default-dp.png'" alt="avatar" class="avatar" />
              <div>
                <div>{{ selectedEmployee.username || "" }}</div>
                <div class="text-muted">{{ selectedEmployee.email }}</div>
              </div>
            </div>

            <small class="text-muted">
              Email will be send to this employee
            </small>
          </div>

          <div>
            <label class="cc-label">
              CC (Select recipients to copy)
            </label>

            <div class="cc-container">
              <div v-for="user in companyEmployees" :key="user.uid" class="cc-item">
                <input type="checkbox" class="cc-checkbox" :value="user.email" v-model="ccRecipients" style="margin-top: 10px;" />

                <div style="display: flex; align-items: center; gap: 10px;">
                  <img class="cc-avatar" style="width: 32px; height: 32px; border-radius: 20px; padding: 2px; border: 2px solid gray" :src="user.profile_picture || 'static/img/default-dp.png'" alt="avatar" />

                  <div class="cc-info">
                    <div class="cc-name">
                      {{ user.username || "" }}
                      <span v-if="user.role === 'admin'" class="admin-badge">Admin</span>
                    </div>
                    <div class="cc-email">
                      {{ user.email }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <small v-if="errors.ccRecipients" class="text-danger">{{ errors.ccRecipients }}</small>
            <small v-else class="text-muted">
              {{ ccRecipients.length }} recipients selected for CC
              (Admins pre-selected by default)
            </small>
          </div>

          <div v-if="newStatus === 'Terminated'">
            <label>
              Termination Date <span class="text-danger">*</span>
            </label>
            <input type="date" v-model="terminationDate" class="form-control"
              @change="updateEmailBodyDates" />
            <small class="text-danger">
              <span style="font-weight: 600;">Note:</span> Termination is effective immediately. Last working date is the same as the termination date.
            </small>
          </div>
          <div v-if="newStatus === 'Resigned'" class="row">
            <div class="col-md-6">
              <label>
                Resignation Approval Date <span class="text-danger">*</span>
              </label>
              <input type="date" v-model="resignationApprovalDate" class="form-control"
                @change="updateEmailBodyDates" />
            </div>
            <div class="col-md-6">
              <label>Last Working Date</label>
              <input type="date" class="form-control" v-model="lastWorkingDate"
                @change="updateEmailBodyDates" />   <!-- ← added this @change -->
              <small class="text-muted">
                Auto-calculated: +{{ noticePeriodDays() }} days from approval date
                (can be manually adjusted)
              </small>
            </div>
          </div>

          <div>
            <label>
              Subject <span class="text-danger">*</span>
            </label>
            <input type="text" v-model="subject" class="form-control" />
            <small v-if="errors.subject" class="text-danger">{{ errors.subject }}</small>
            <small v-else class="text-muted">
              Auto generated, but you can edit it
            </small>
          </div>

          <div>
            <label class="mt-2">
              Email Body <span class="text-danger">*</span>
            </label>
            <textarea rows="6" v-model="emailBody" class="form-control"></textarea>
            <small v-if="errors.emailBody" class="text-danger">{{ errors.emailBody }}</small>
            <small v-else class="text-muted">
              Auto generated based on employment status change, fully editable
            </small>
          </div>
        </div>
      </ReuseableModal>

      <ReuseableModal :modelValue="isNotesModalOpen" @update:modelValue="isNotesModalOpen = $event"
        :title="'Notes for ' + (selectedEmployee.username || '')" :isLarge="true" :scrollable="true"
        submitButtonText="Save & Preview Email" @submit="submitNote" :loading="isSubmitting">
        <div style="display: flex; flex-direction: column; gap: 20px;">

          <div v-if="selectedEmployee && selectedEmployee.promotionInfo && selectedEmployee.promotionInfo.length">
            <p style="font-weight: 800;">Existing Notes</p>

            <div v-for="(note, index) in selectedEmployee.promotionInfo" :key="note.id" class="note-card" :ref="index === selectedEmployee.promotionInfo.length - 1 ? 'lastNote' : null">
              <div class="note-header">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <span class="badge" :style="{ backgroundColor: note.isSalaryPromotion ? '#d1e7dd' : '#cfe2ff', color: note.isSalaryPromotion ? '#0f5132' : '#084298' }">
                    {{ note.isSalaryPromotion ? 'Salary Increment' : 'Regular Note' }}
                  </span>
                  <span class="note-date">{{ formatDate(note.effectiveDate) || formatDate(note.createdAt) }}</span>
                </div>

                <!-- outline icon -->
                <i class="far fa-trash-alt" style="cursor: pointer;" @click="openDeletePromotionModal(index, note)"></i>
              </div>

              <p>{{ note.text || ( note.isSalaryPromotion ? '' : 'No note content available.' ) }}</p>

              <!-- Salary Details -->
              <div v-if="note.type && note.type === 'increment'" class="salary-box">
                <div>Old Salary: PKR {{ note.oldSalary.toLocaleString('en-PK') }}</div>
                <div>New Salary: PKR {{ (note.newBasicSalary + note.newExtraAllowance).toLocaleString('en-PK') }}</div>
                <div class="text-success">
                  Increment: Rs. {{ note.increment.toLocaleString('en-PK') }} ({{ note.percentage }}%)
                </div>
              </div>
            </div>
          </div>

          <hr v-if="selectedEmployee && selectedEmployee.promotionInfo && selectedEmployee.promotionInfo.length" style="margin-top: 0; margin-bottom: 0;" />

          <div>
            <p style="font-weight: 800;">Add New Note</p>

            <!-- Note Type -->
            <div class="mb-2">
              <label style="font-weight: 500;">Note Type</label>

              <div class="d-flex gap-3 mt-1">
                <label style="width: min-content">
                  <input type="radio" value="regular" v-model="noteType" />
                  Regular Note
                </label>

                <label>
                  <input type="radio" value="increment" v-model="noteType" />
                  Salary Increment
                </label>
              </div>
            </div>

            <div v-if="noteType === 'increment'" class="salary-form">
              <div class="row">
                <div class="col-md-6">
                  <label>Current Salary</label>
                  <input type="number" v-model="currentSalary" disabled style="background: #ffffff;" class="form-control" />
                  <small v-if="notesErrors.currentSalary" class="text-danger">{{ notesErrors.currentSalary }}</small>
                  <small v-else class="text-muted">
                    {{ "Basic Salary: " + selectedEmployee.basicSalary + " and Extra Allowance: " + selectedEmployee.extraAllowance }}
                  </small>
                </div>

                <div class="col-md-6">
                  <label>New Basic Salary <span class="text-danger">*</span></label>
                  <input type="number" v-model="newBasicSalary" class="form-control" style="background: #ffffff;" />
                  <small v-if="notesErrors.newBasicSalary" class="text-danger">{{ notesErrors.newBasicSalary }}</small>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-md-6">
                  <label>New Extra Allowance <span class="text-danger">*</span></label>
                  <input type="number" v-model="newExtraAllowance" class="form-control" style="background: #ffffff;" />
                  <small v-if="notesErrors.newExtraAllowance" class="text-danger">{{ notesErrors.newExtraAllowance }}</small>
                </div>
               <div class="col-md-6">
                  <label>Effective Date <span class="text-danger">*</span></label>
                  <input type="date" v-model="effectiveDate" class="form-control" style="background: #ffffff;" />
                  <small v-if="notesErrors.effectiveDate" class="text-danger">{{ notesErrors.effectiveDate }}</small>
                </div>
              </div>

              <!-- Increment Preview -->
              <div v-if="currentSalary && newBasicSalary && newExtraAllowance" class="increment-box">
                Increment: PKR
                {{ (Number(newBasicSalary) + Number(newExtraAllowance) - Number(currentSalary)).toLocaleString('en-PK') }}
                ({{ calculatePercentage() }}%)
              </div>
            </div>

            <div class="mt-3">
              <label style="font-weight: 500;">Note Content</label>

              <textarea rows="4" v-model="noteContent"
                :placeholder="noteType === 'increment' ? 'Enter note about salary increment (e.g., reason, performance highlights)' : 'Enter note content'"
                class="form-control"></textarea>
                <small v-if="notesErrors.noteContent" class="text-danger">{{ notesErrors.noteContent }}</small>

              <small v-else class="text-muted">
                {{ noteType === 'increment' ? "This note will be included in the salary increment email" : "This note will be included in the notification email" }}
              </small>
            </div>
          </div>
        </div>
      </ReuseableModal>

      <ReuseableModal :modelValue="isNotesEmailPreviewModalOpen" @update:modelValue="isNotesEmailPreviewModalOpen = $event"
        title="Review & Send Note Email" :isLarge="true" :scrollable="true" submitButtonText="Send Email and Save Note"
        @submit="submitNote" :loading="isSubmitting">
        <div style="display: flex; flex-direction: column; gap: 18px;">

          <!-- Info Box -->
          <div class="info-box"

            style="background: #f0f6ff; border-radius: 10px; padding: 16px 20px; border: 1px solid #d0e4ff;">
            <div style="display: flex; flex-direction: column; gap: 6px;">
              <div>
                <span style="color: #2a6db5; font-weight: 600;">Employee: </span>
                <span style="color: #2a6db5;">{{ selectedEmployee.username || '' }}</span>
              </div>
              <div>
                <span style="color: #2a6db5; font-weight: 600;">Note Type: </span>
                <span style="color: #2a6db5;">{{ noteType === 'increment' ? 'Salary Increment' : 'Regular Note' }}</span>
              </div>
              <hr v-if="noteType === 'increment'" style="border-color: #c8dff8; margin: 6px 0;" />
              <div v-if="noteType === 'increment'">
                <div>
                  <span style="color: #2a6db5; font-weight: 600;">Salary Details:</span>
                </div>
                <div>
                  <span style="color: #2a6db5;">Current Salary: Rs. {{ Number(currentSalary).toLocaleString('en-PK') }}</span>
                </div>
                <div>
                  <span style="color: #2a6db5;">New Salary: Rs. {{ (Number(newBasicSalary) +
                    Number(newExtraAllowance)).toLocaleString('en-PK') }}</span>
                </div>
                <div>
                  <span style="color: green">Increment: Rs. {{ (Number(newBasicSalary) + Number(newExtraAllowance) -
                    Number(currentSalary)).toLocaleString('en-PK') }} ({{ calculatePercentage() }}%)</span>
                </div>
              </div>
            </div>
          </div>

          <!-- To -->
          <div>
            <label style="font-weight: 500; margin-bottom: 6px; display: block;">
              To <span class="text-danger">*</span>
            </label>
            <div
              style="display: flex; align-items: center; gap: 12px; background: #f3fbf4; border: 1px solid #c3e6cb; border-radius: 8px; padding: 10px 14px;">
              <img style="width: 36px; height: 36px; border-radius: 20px; padding: 2px; border: 2px solid gray"
                :src="selectedEmployee.profile_picture || 'static/img/default-dp.png'" alt="avatar" />
              <div>
                <div style="font-weight: 600;">{{ selectedEmployee.username || "" }}</div>
                <div style="color: #888; font-size: 13px;">{{ selectedEmployee.email }}</div>
              </div>
            </div>
            <small class="text-muted">Email will be sent to this employee</small>
          </div>

          <!-- CC -->
          <div>
            <label style="font-weight: 500; margin-bottom: 6px; display: block;">
              CC <span style="color: #888; font-weight: 400;">(Select recipients to copy)</span>
            </label>
            <div style="border: 1px solid #ddd; border-radius: 8px; overflow: hidden;">
              <div v-for="user in companyEmployees"
                :key="user.uid"
                style="display: flex; align-items: center; gap: 12px; padding: 10px 14px; border-bottom: 1px solid #f0f0f0;">
                <input type="checkbox" :value="user.email" v-model="ccRecipients"
                  class="cc-checkbox" style="margin-top: 10px;" />
                <img style="width: 36px; height: 36px; border-radius: 20px; padding: 2px; border: 2px solid gray"
                  :src="user.profile_picture || 'static/img/default-dp.png'" alt="avatar" />
                <div>
                  <div style="font-weight: 500; display: flex; align-items: center; gap: 6px;">
                    {{ user.username || "" }}
                    <span v-if="user.role === 'admin'"
                      style="font-size: 11px; background: #ede9fe; color: #7c3aed; border-radius: 4px; padding: 1px 7px; font-weight: 500;">
                      Admin
                    </span>
                  </div>
                  <div style="color: #888; font-size: 13px;">{{ user.email }}</div>
                </div>
              </div>
            </div>
            <small v-if="errors.ccRecipients" class="text-danger">{{ errors.ccRecipients }}</small>
            <small v-else style="color: #2563eb; font-size: 12px;">
              {{ ccRecipients.length }} recipient(s) selected for CC
              <span style="color: #888;">(Admins pre-selected by default)</span>
            </small>
          </div>

          <!-- Subject -->
          <div>
            <label style="font-weight: 500; margin-bottom: 6px; display: block;">
              Subject <span class="text-danger">*</span>
            </label>
            <input type="text" v-model="subject" class="form-control" style="border-radius: 8px;" />
            <small v-if="errors.subject" class="text-danger">{{ errors.subject }}</small>
            <small v-else class="text-muted">Auto-generated, but you can edit it</small>
          </div>

          <!-- Email Body -->
          <div>
            <label style="font-weight: 500; margin-bottom: 6px; display: block;">
              Email Body <span class="text-danger">*</span>
            </label>
            <textarea rows="8" v-model="emailBody" class="form-control"
              style="font-family: monospace; font-size: 13px; border-radius: 8px; resize: vertical;"></textarea>
            <small v-if="errors.emailBody" class="text-danger">{{ errors.emailBody }}</small>
            <small v-else class="text-muted">Auto-generated based on note type, fully editable</small>
          </div>

        </div>
      </ReuseableModal>

      <ReuseableModal :modelValue="isDeletePromotionModalOpen" @update:modelValue="isDeletePromotionModalOpen = $event"
        title="Confirm Deletion" submitButtonText="Delete" @submit="deleteNote" :loading="loadings.deletingNote">
        <div>Are you sure you want to delete this note?</div>
      </ReuseableModal>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert";
import constants from "src/assets/config/constants.js";
import firebase from "src/assets/config/firebase.js";
import CustomTable from "src/components/UIComponents/CustomTable.vue";
import Card from "src/components/UIComponents/Cards/Card.vue";
import ReuseableModal from "src/components/UIComponents/ReuseableModal.vue"; 
import banksData from "src/components/data/banks.json";
import CustomDropdown from '../UIComponents/CustomDropdown.vue';
import GradeDropdown from '../UIComponents/GradeDropdown.vue';
import Status from './Status.vue';
import PencilIcon from 'src/assets/icons/PencilIcon.js';
import filterEmployees from "../../utils/activeInactiveUser.js"
import EmployeeDropdown from "../UIComponents/EmployeeDropdown.vue"
// import { designations, designationGrades } from '../dashboard/views/UserProfile/ProfileData.js'; 
import { designations, designationGrades } from '../Dashboard/Views/UserProfile/ProfileData.js';
import { logAdminActivity, createActivityPayload } from "../../utils/adminLogs.js";
import { STATIC_TEMPLATES } from "../../assets/config/constants.js";
import MeetingModal from './../GoogleCalender/MeetingModal.vue'
import { createMeeting, deleteMeeting as deleteUserMeeting, updateMeeting, isGoogleCalendarConnected, listUpcomingEvents, initGapi } from '../../utils/googleCalendar.js'
import { handleActivityNotification } from "../../services/notificationService.js";

export default {
  components: { 
    Card, 
    CustomTable,
    ReuseableModal,
    CustomDropdown,
    GradeDropdown,
    Status,
    PencilIcon,
    EmployeeDropdown,
    MeetingModal
  },
  created: function() {
    let store = this.$store;
    if (store.state.constants && store.state.constants.constant) {
      this.plan = store.state.constants.constant.plan || "premium";
      this.usersAllow = store.state.constants.constant.usersAllow || 10;
    } else {
      this.plan = "premium";
      this.usersAllow = 10;
    }
    this.items = store.state.auth && store.state.auth.allUsers ? store.state.auth.allUsers : [];
    store.commit("loadingStarts");
    if (this.items.length) {
      store.commit("loadingEnds");
    }
    if (store.getters && store.getters.allUsers) {
      store.watch(store.getters.allUsers, allUsers => {
        this.items = store.state.auth && store.state.auth.allUsers ? store.state.auth.allUsers : [];
        store.commit("loadingEnds");
      });
    }
  },
  data() {
    return {
      noteType: 'regular',
      existingNotes: [],

      currentSalary: '',
      newBasicSalary: '',
      newExtraAllowance: '',
      effectiveDate: '',
      
      noteContent: '',
      isNotesModalOpen: false,
      isNotesEmailPreviewModalOpen: false,
      isStatusChangeModalOpen: false,
      isSubmitting: false,
      selectedEmployee: {},
      oldStatus: "",
      newStatus: "",
      templates: [],
      selectedTemplate: {},
      subject: "",
      emailBody: "",
      ccRecipients: [],
      terminationDate: "",
      resignationApprovalDate: Date.now(),
      lastWorkingDate: Date.now() + 30 * 24 * 60 * 60 * 1000,
      errors: {
        ccRecipients: "",
        subject: "",
        emailBody: "",
        resignationApprovalDate: "",
        terminationDate: "",
      },
      notesErrors: {
        currentSalary: "",
        newBasicSalary: "",
        newExtraAllowance: "",
        effectiveDate: "",
        noteContent: "",
      },
      showModal: false,
      isMeetingConfirmModalOpen: false,
      meetingType: "",
      selectedMeeting: null,
      meetings: [],
      loadings: { saveMeeting: false, deleteMeeting: false, deletingNote: false },
      filteredUsers:[],
      company: this.$store.state.auth.company,
      currentUser: this.$store.state.auth.user,
      isLoading: false,
      nameError: "",
      emailError: "",
      isAdmin: false,
      searchTerm: "",
      max25chars: v => v.length <= 25 || "Input too long!",
      dialog: false, 
      tmp: "", 
      search: "", 
      email: "", 
      name: "", 
      designation: "", 
      grade: "",
      designations,
      designationGrades,
      pagination: {}, 
      items: [], 
      plan: "premium", 
      usersAllow: 10, 
      allusers: 0,
      isDeleteModalOpen: false,
      isEmployeeModalOpen: false,
      banks: banksData.banks,
      isEdit: false, 
      editUserId: "", 
      selectedUser: null, 
      isAddingEmployee: false,
      activeOptions: ['Active', 'InActive'], // Options for Active column
      roleOptions: ['admin', 'user'],
      promotionText: "",
      isSalaryPromotion: false,
      newBasicSalary: null,
      newExtraAllowance: null,
      promotionEditIndex: null,
      selectedPromotionUser: null,
      isPromotionModalOpen: false,
      isDeletePromotionModalOpen: false,
      promotionToDelete: null,
      shift: "Morning", 
      shiftOptions: ["Morning", "Night"],
      shiftError: "",
      lastWorkingDateManuallySet: false,
      tableColumns: [
        { label: "Avatar", key: "profile_picture", sticky: "left", width: 70 },
        { label: "Name", key: "username", sticky: "left", sortable: true, width: 140 },
        { label: "Designation", key: "designation", sortable: true, width: 180 },
        { label: "Grade", key: "grade" , sortable: true, width: 70},
        { label: "Shift", key: "shift", sortable: true, width: 100 },
        { label: "Company Email", key: "email", sortable: true, width: 250 },
        { label: "Personal Email", key: "personalEmail", sortable: true, width: 220 },
        { label: "Date of Birth", key: "dateOfBirth", sortable: true, width: 180},
        { label: "Joining Date", key: "joiningDate" , sortable: true, width: 180},
        { label: "Bank Name", key: "bankName" , sortable: true, width: 180},
        { label: "IBAN", key: "iban" , sortable: true ,width: 180},
        { label: "Nationality", key: "nationality", sortable: true, width: 200},
        { label: "Marital Status", key: "maritalStatus", sortable: true, width: 180 },
        { label: "Phone Number", key: "phoneNumber", sortable: true, width: 180 },
        { label: "Current Address", key: "currentAddress", sortable: true, width: 180 },
        { label: "Permanent Address", key: "permanentAddress", sortable: true, width: 180 },
        { label: "Relative Name", key: "emergencyContactName", sortable: true, width: 180 },
        { label: "Relative Number", key: "emergencyContactNumber", sortable: true, width: 180 },
        { label: "CNIC Image", key: "nicImageUrl", width: 130 },
        { label: "Experience letter", key: "certificateUrl", width: 130 },
        { label: "Salary Slip", key: "salarySlipUrl", width: 130 },
        { label: "Active", key: "active", width: 180 },
        { label: "Status", key: "status", width: 180 },
        { label: "Notes", key: "promotionInfo", width: 250 },
        { label: "Next Quarterly Meeting", key: "nextQuarterlyMeeting", width: 200 },
        { label: "Next Increment Review Meeting", key: "nextIncrementReview", width: 200 },
        { label: "Resigned", key: "resignationDate", width: 200 },
        { label: "Last Working Date", key: "lastWorkingDate", width: 200 },
        { label: "Duration Spent", key: "durationSpent", width: 200 },
        { label: "Admin", key: "role", width: 180 },
        { label: "Action", key: "action", sticky: "right", width: 100 }
      ]
    };
  },
  computed: {
    companyEmployees() {
      const companyUserIds = this.$store.state.auth.company.users.map(user => user.uid)

      return this.$store.state.auth.allUsers.filter(u =>
        companyUserIds.includes(u.uid) &&
        u.uid !== this.selectedEmployee.uid &&
        u.isActive
      )
    },
    loading() { return this.$store.state.loading || false; },
    filteredUsers() {
      const company = this.$store.state.auth.company;
      const companyUserIds = company.users.map(user => user.uid);
      const allUsers = this.$store.state.auth.allUsers.filter(user =>
        companyUserIds.includes(user.uid)
      );
      if (this.searchTerm) {
        return allUsers.filter(user => {
          const name = user.username ? user.username.toLowerCase() : "";
          const email = user.email ? user.email.toLowerCase() : "";
          const searchTerm = this.searchTerm.toLowerCase();
          return name.includes(searchTerm) || email.includes(searchTerm);
        });
      } 
      return allUsers;
    },
    isCurrentUserAdmin() {
      return this.$store.state.auth.user.role === "admin";
    },
  },
  watch: {
    lastWorkingDate(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.lastWorkingDateManuallySet = true;
      }
      this.updateEmailBodyDates();
    },

    resignationApprovalDate(newDate) {
      if (!newDate) {
        this.lastWorkingDate = "";
        this.lastWorkingDateManuallySet = false;
        this.updateEmailBodyDates();
        return;
      }

      if (!this.lastWorkingDateManuallySet && this.newStatus === 'Resigned') {
        const date = new Date(newDate);
        const noticePeriod = this.oldStatus === "Probation" ? 15 : 30;
        date.setDate(date.getDate() + noticePeriod);
        this.lastWorkingDate = date.toISOString().split("T")[0];
      }

      this.updateEmailBodyDates();
    },

    terminationDate(newVal) {
      if (this.newStatus === 'Terminated' && newVal) {
        this.lastWorkingDate = newVal;
        this.lastWorkingDateManuallySet = true;
        this.updateEmailBodyDates();
      }
    },
    newStatus(newVal) {
      if (newVal === 'Terminated' && this.terminationDate) {
        this.lastWorkingDate = this.terminationDate;
        this.lastWorkingDateManuallySet = true;
        this.updateEmailBodyDates();
      }
    },

    isStatusChangeModalOpen(isOpen) {

      if (!isOpen) {
        this.resetStatusChangeState();
        return;
      }

      const today = this.getTodayDate();

      if (this.newStatus === "Resigned") {
        this.resignationApprovalDate = today;
        this.lastWorkingDateManuallySet = false;   
      }

      if (this.newStatus === "Terminated") {
        this.terminationDate = today;
        this.lastWorkingDate = today;             
        this.lastWorkingDateManuallySet = true;
      }

      const values = this.getTemplateValues({
        employee: this.selectedEmployee,
        newStatus: this.newStatus,
        oldStatus: this.oldStatus
      });

      this.subject = this.replacePlaceholders(
        this.selectedTemplate.subject,
        values
      );

      this.emailBody = this.replacePlaceholders(
        this.selectedTemplate.body,
        values
      );
      this.$nextTick(() => {
        this.updateEmailBodyDates();
      });
    },

    isNotesModalOpen(isOpen) {
      if (!isOpen && !this.isNotesEmailPreviewModalOpen) {
        this.resetNoteState();
      }
      if (isOpen) {
        this.$nextTick(() => {
          const lastNote = this.$refs.lastNote;
          const el = Array.isArray(lastNote) ? lastNote[lastNote.length - 1] : lastNote;
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    },
    isNotesEmailPreviewModalOpen(isOpen) {
      if (!isOpen) {
        this.resetNoteState();
      }
    }
  },
  mounted() {
    this.fetchEmailTemplates();
  },
  methods: {
    async deleteNote() {
      if (this.loadings.deletingNote) return;
      this.loadings.deletingNote = true;
      const { index, note } = this.promotionToDelete;
      try {
        await firebase.deletePromotionInfo(this.selectedEmployee.uid, index)

        let title = `${this.currentUser.username} deleted a note for ${this.selectedEmployee.username}`;
        const isIncrement = note.isSalaryPromotion;

        let description = `${this.currentUser.email} deleted a note from ${this.selectedEmployee.username}'s profile.

Note Details:
- Text: "${note.text}"
- Type: ${isIncrement ? 'Salary Increment' : 'Regular Note'}
${isIncrement ? `- Effective Date: ${note.effectiveDate || this.formatDate(note.createdAt)}` : ''}
${isIncrement ? `- Old Salary: ${note.oldSalary.toLocaleString('en-PK')}` : ''}
${isIncrement ? `- New Salary: ${(note.newBasicSalary + note.newExtraAllowance).toLocaleString('en-PK')}` : ''}
${isIncrement ? `- Increment: ${note.increment.toLocaleString('en-PK')} (${note.percentage}%)` : ''}`;

        await logAdminActivity(
          createActivityPayload({
            user: this.currentUser,
            title,
            description,
            username: this.selectedEmployee.username,
            type: "delete_note",
            uid: this.selectedEmployee.uid
          })
        );

        swal("Deleted", "Note has been deleted successfully", "success");
      } catch (error) {
        console.error("Error deleting promotion info:", error);
        swal("Oops!", "Failed to delete note", "error");
      } finally {
        this.loadings.deletingNote = false;
        this.isDeletePromotionModalOpen = false;
        this.selectedEmployee.promotionInfo.splice(index, 1);
      }
    },
    resolveTemplateVariables(text) {
      if (!text) return '';

      const emp = this.selectedEmployee;
      const now = new Date();

      const variables = {
        '[Employee Name]': emp.username || '',
        '[Effective Date]': this.effectiveDate || '',
        '[Current Time]': now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }),
        '[Current Date]': now.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
        '[Old Salary]': `PKR ${this.currentSalary.toLocaleString('en-PK')}` || '',
        '[New Salary]': `PKR ${(Number(this.newBasicSalary) + Number(this.newExtraAllowance)).toLocaleString('en-PK')}` || '',
        '[Increment Amount]': `PKR ${((Number(this.newBasicSalary) + Number(this.newExtraAllowance)) - Number(this.currentSalary)).toLocaleString('en-PK')}` || '',
        '[Increment Percentage]': this.calculatePercentage() || '',
        '[Note Text]': this.noteContent || '',
        '[Admin Name]': this.currentUser.username || '',
      };

      return Object.entries(variables).reduce((result, [placeholder, value]) => {
        return result.replaceAll(placeholder, value);
      }, text);
    },
    resetNoteState () {
      this.noteType = 'regular';
      this.currentSalary = '';
      this.newBasicSalary = '';
      this.newExtraAllowance = '';
      this.effectiveDate = '';
      this.noteContent = '';
      this.ccRecipients = [];
      this.subject = '';
      this.emailBody = '';
      this.selectedTemplate = {};
      this.notesErrors = {
        currentSalary: "",
        newBasicSalary: "",
        newExtraAllowance: "",
        effectiveDate: "",
        noteContent: "",
      };
    },
    async submitNote () {
      if (this.noteType === 'increment') {
        if (!this.currentSalary) {
          this.notesErrors.currentSalary = "Current salary is required.";
          return;
        } else {
          this.notesErrors.currentSalary = "";
        }

        if (!this.newBasicSalary) {
          this.notesErrors.newBasicSalary = "New basic salary is required.";
          return;
        } else {
          this.notesErrors.newBasicSalary = "";
        }

        if (!this.newExtraAllowance) {
          this.notesErrors.newExtraAllowance = "New extra allowance is required.";
          return;
        } else {
          this.notesErrors.newExtraAllowance = "";
        }

        if (!this.effectiveDate) {
          this.notesErrors.effectiveDate = "Effective date is required.";
          return;
        } else {
          this.notesErrors.effectiveDate = "";
        }
      }

      if (!this.isNotesEmailPreviewModalOpen) {
        this.isNotesEmailPreviewModalOpen = true;
        this.preselectAdminsForCC();
        this.isNotesModalOpen = false;

        let statusForTemplate = this.noteType === 'increment' ? 'Increase' : 'Note';

        this.selectedTemplate = this.templates.find(t =>
          t.title.includes(statusForTemplate)
        );
        if (!this.selectedTemplate) {
          this.subject = "";
          this.emailBody = "";
          return;
        } else {
          this.subject = this.selectedTemplate.subject.replace('[Employee Name]', this.selectedEmployee.username);
          this.emailBody = this.resolveTemplateVariables(this.selectedTemplate.body);
        }
        return;
      }

      if (!this.validateStatusChangeForm()) {
        console.log("Form validation failed", this.errors);
        return;
      }

      const payload = {
        userId: this.selectedEmployee.uid,
        type: this.noteType,
        text: this.noteContent,
      }
      if (this.noteType === 'increment') {
        payload.oldSalary = this.currentSalary;
        payload.newBasicSalary = Number(this.newBasicSalary);
        payload.newExtraAllowance = Number(this.newExtraAllowance);
        payload.increment = payload.newBasicSalary + payload.newExtraAllowance - payload.oldSalary;
        payload.percentage = this.calculatePercentage();
        payload.effectiveDate = this.effectiveDate;
      }
      let formData = {
        to: this.selectedEmployee.email,
        subject: this.subject,
        message: this.emailBody,
        cc: this.ccRecipients,
      };
      
      this.isSubmitting = true;
      await this.savePromotion(payload)

      let title = `${this.currentUser.username} added a note for ${this.selectedEmployee.username}`;
      const isIncrement = payload.type === 'increment';

      let description = `${this.currentUser.email} added a note on ${this.selectedEmployee.username}'s profile.

Note Details:
- Text: "${payload.text}"
- Type: ${isIncrement ? 'Salary Increment' : 'Regular Note'}
${isIncrement ? `- Effective Date: ${payload.effectiveDate }` : ''}
${isIncrement ? `- Old Salary: ${payload.oldSalary.toLocaleString('en-PK')}` : ''}
${isIncrement ? `- New Salary: ${(payload.newBasicSalary + payload.newExtraAllowance).toLocaleString('en-PK')}` : ''}
${isIncrement ? `- Increment: ${payload.increment.toLocaleString('en-PK')} (${payload.percentage}%)` : ''}`;

      await logAdminActivity(
        createActivityPayload({
          user: this.currentUser,
          title,
          description,
          username: this.selectedEmployee.username,
          type: "create_note",
          uid: this.selectedEmployee.uid
        })
      );

      try {
        const response = await fetch(`${constants.serverURL}/company/change-status`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData)
        }).catch(error => {
          console.error("Fetch error:", error);
          throw new Error(`Failed to connect to server at ${serverURL}. Please ensure the backend server is running and accessible.`);
        });
        swal("Success", "Note updated and email sent successfully", "success");
      } catch (error) {
        console.error("Error updating status:", error);
        swal("Error", "Failed to update status", "error");
      } finally {
        this.isSubmitting = false;
        this.isNotesEmailPreviewModalOpen = false;
        this.resetNoteState();
      }
    },
    calculatePercentage() {
      if (!this.currentSalary || !this.newBasicSalary || !this.newExtraAllowance) return 0
      return ((((Number(this.newBasicSalary) + Number(this.newExtraAllowance)) - Number(this.currentSalary)) / Number(this.currentSalary)) * 100).toFixed(2)
    },
    updateEmailBodyDates() {
      if (!this.emailBody) return;

      const format = (dateStr) => {
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('en-GB');
      };

      const approval = format(this.resignationApprovalDate);
      const termination = format(this.terminationDate);
      const lastWorking = format(this.lastWorkingDate);

      const noticeDays = this.newStatus === 'Resigned' ? this.noticePeriodDays() : 0;
      const baseStatus = this.oldStatus || 'Permanent';
      const noticeLine = `Notice Period: ${noticeDays} days (based on ${baseStatus} status)`;

      let body = this.emailBody;
      body = body
        .replace(/^Resignation Approval Date:.*$/im, '')
        .replace(/^Last Working Date:.*$/im, '')
        .replace(/^Notice Period:.*$/im, '')
        .replace(/^Termination Date:.*$/im, '')
        .replace(/\[(Approval Date|Termination Date|Last Working Date|Current Date):[^\]]*\][\s\r\n]*/gi, '')
        .replace(/\n{3,}/g, '\n\n')
        .trim();

      if (this.newStatus === 'Resigned') {
        if (/Notice Period:/i.test(body)) {
          body = body.replace(
            /Notice Period:[^\n\r]*/i,
            noticeLine
          );
        } else if (/New Status:\s*Resigned/i.test(body)) {
          body = body.replace(
            /(New Status:\s*Resigned[^\n]*\n?)/i,
            `$1${noticeLine}\n`
          );
        } else if (noticeDays > 0) {
          if (/New Status:\s*Resigned/i.test(body)) {
            body = body.replace(
              /(New Status:\s*Resigned[^\n]*)/i,
              `$1\n${noticeLine}`
            );
          } else {
            body += `\n${noticeLine}`;
          }
        }

        if (approval) {
          if (/Resignation Approval Date:/i.test(body)) {
            body = body.replace(
              /Resignation Approval Date:[^\n\r]*/i,
              `Resignation Approval Date: ${approval}`
            );
          } else {
            if (/New Status:/i.test(body)) {
              body = body.replace(
                /(New Status:[^\n]*)/i,
                `$1\nResignation Approval Date: ${approval}`
              );
            } else {
              body += `\nResignation Approval Date: ${approval}`;
            }
          }
        }

        if (lastWorking) {
          if (/Last Working Date:/i.test(body)) {
            body = body.replace(
              /Last Working Date:[^\n\r]*/i,
              `Last Working Date: ${lastWorking}`
            );
          } else {
            if (/Resignation Approval Date:/i.test(body)) {
              body = body.replace(
                /(Resignation Approval Date:[^\n]*)/i,
                `$1\nLast Working Date: ${lastWorking}`
              );
            } else if (/Notice Period:/i.test(body)) {
              body = body.replace(
                /(Notice Period:[^\n]*)/i,
                `$1\nLast Working Date: ${lastWorking}`
              );
            } else {
              body += `\nLast Working Date: ${lastWorking}`;
            }
          }
        }
      }

      if (this.newStatus === 'Terminated' && termination) {
        const theDate = termination; 

        if (/Termination Date:/i.test(body)) {
          body = body.replace(
            /Termination Date:[^\n\r]*/i,
            `Termination Date: ${theDate}`
          );
        } else if (/termination date/i.test(body)) {
          body = body.replace(
            /termination date:[^\n\r]*/i,
            `Termination Date: ${theDate}`
          );
        } else {
          body += `\nTermination Date: ${theDate}`;
        }

        if (/Last Working Date:/i.test(body)) {
          body = body.replace(
            /Last Working Date:[^\n\r]*/i,
            `Last Working Date: ${theDate}`
          );
        } else {
          body += `\nLast Working Date: ${theDate}`;
        }

        if (/terminated effective/i.test(body)) {
          body = body.replace(
            /terminated effective\s*[^\n\r.]*/i,
            `terminated effective ${theDate}`
          );
        } else if (/effective\s*(immediately|on|\d)/i.test(body)) {
          body = body.replace(
            /effective\s*[^\n\r.]*/i,
            `effective ${theDate}`
          );
        } else {
          body += `\nWe regret to inform you that your employment with our organization has been terminated effective ${theDate}.`;
        }
      }

      this.emailBody = body
        .replace(/\n{3,}/g, '\n\n')
        .trim();
    },
    calculateDaysDifference(startDate, endDate) {
      console.log("Calculating days difference between", startDate, "and", endDate);
      if (!startDate || !endDate) return 0;

      const start = new Date(startDate);
      const end = new Date(endDate);

      const diffTime = end.getTime() - start.getTime();
      return Math.max(Math.ceil(diffTime / (1000 * 60 * 60 * 24)), 0);
    },
    getTodayDate() {
      return new Date().toISOString().split("T")[0];
    },
    async fetchEmailTemplates() {
      try {
        const dbTemplatesObj = await firebase.getEmailTemplates();
        console.log("Fetched templates from DB:", dbTemplatesObj);

        if (!dbTemplatesObj) {
          this.templates = [...STATIC_TEMPLATES];
          return;
        }

        const dbTemplates = Object.entries(dbTemplatesObj).map(
          ([key, value]) => ({
            ...value,
            dbId: key
          })
        );

        this.templates = this.mergeTemplates(STATIC_TEMPLATES, dbTemplates);
      } catch (error) {
        console.error("Failed to fetch email templates", error);
        this.templates = [...STATIC_TEMPLATES];
      }
    },
    mergeTemplates(staticTemplates, dbTemplates) {
      const staticMap = new Map();

      staticTemplates.forEach(t => {
        staticMap.set(t.title, { ...t });
      });

      dbTemplates.forEach(dbTemplate => {
        if (staticMap.has(dbTemplate.title)) {
          staticMap.set(dbTemplate.title, {
            ...staticMap.get(dbTemplate.title),
            ...dbTemplate,
            id: staticMap.get(dbTemplate.title).id
          });
        } else {
          staticMap.set(dbTemplate.title, dbTemplate);
        }
      });

      return Array.from(staticMap.values());
    },
    async submitStatusChange() {
      if (!this.validateStatusChangeForm()) {
        console.log("Form validation failed", this.errors);
        return;
      }
      try {
        let formData = {
          to: this.selectedEmployee.email,
          subject: this.subject,
          message: this.emailBody,
          cc: this.ccRecipients,
        };
        this.isSubmitting = true;

        const uid = this.selectedEmployee.uid;

        await firebase.updateUserStatus(this.newStatus, uid);
        await firebase.updateUserPreviousStatus(this.oldStatus, uid);
        this.selectedEmployee.status = this.newStatus;
        this.selectedEmployee.previousStatus = this.oldStatus;

        if (this.newStatus === "Permanent") {
          await this.assignLeaves(this.selectedEmployee);
        }

        if (this.newStatus === "Resigned" && !this.selectedEmployee.resignationDate) {
          this.selectedEmployee.resignationDate = new Date().toISOString().split("T")[0];
          await firebase.updateUserResignationDate(
            this.selectedEmployee.resignationDate,
            this.selectedEmployee.uid
          );
        } else if (this.newStatus !== "Resigned") {
          this.selectedEmployee.resignationDate = null;
          await firebase.updateUserResignationDate(
            this.selectedEmployee.resignationDate,
            this.selectedEmployee.uid
          );
        }

        const response = await fetch(`${constants.serverURL}/company/change-status`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData)
        }).catch(error => {
          console.error("Fetch error:", error);
          throw new Error(`Failed to connect to server at ${serverURL}. Please ensure the backend server is running and accessible.`);
        });

        this.$store.dispatch("fetchAllUsersRealTime");
        swal("Success", "Status updated successfully", "success");

        this.isStatusChangeModalOpen = false;
      } catch (e) {
        swal("Error", "Failed to update status", "error");
      } finally {
        this.isSubmitting = false;
      }
    },
    async assignLeaves(item) {
      try {
        const { leavesAllowed, leavesAvailable } = this.calculateLeaves(item);

        await firebase.updateUserLeaves(item.uid, {
          leavesAllowed,
          leavesTaken: 0,
          leavesAvailable,
        });
        return { leavesAllowed, leavesTaken: 0, leavesAvailable };
      } catch (error) {
        console.error("Error assigning leaves:", error);
        swal("Error", "Failed to assign leaves", "error");
      }
    },
    validateStatusChangeForm () {
      if (!this.ccRecipients.length) {
        this.errors.ccRecipients = "Please select at least one recipient for CC";
        return false;
      } else {
        this.errors.ccRecipients = "";
      }
      if (!this.subject.trim()) {
        this.errors.subject = "Subject is required";
        return false;
      } else {
        this.errors.subject = "";
      }
      if (!this.emailBody.trim()) {
        this.errors.emailBody = "Email body cannot be empty";
        return false;
      } else {
        this.errors.emailBody = "";
      }
      return true;
    },
    resetStatusChangeState() {
      this.selectedEmployee = {};
      this.oldStatus = "";
      this.newStatus = "";
      this.resignationApprovalDate = Date.now();
      this.lastWorkingDate = Date.now() + 30 * 24 * 60 * 60 * 1000;
      this.ccRecipients = [];
      this.subject = "";
      this.emailBody = "";
      this.errors = {
        ccRecipients: "",
        subject: "",
        emailBody: "",
        resignationApprovalDate: "",
        terminationDate: ""
      };
      this.selectedTemplate = null;
      this.terminationDate = "";
    },
    replacePlaceholders(template, values) {
      return template.replace(/\[([^\]]+)\]/g, function (_, key) {
        return values[key] !== undefined && values[key] !== null
          ? values[key]
          : `[${key}]`;
      });
    },
    getTemplateValues({ employee, newStatus, oldStatus }) {
      const now = new Date();
      const time = now.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });

      const commonValues = {
        "Employee Name": employee.username,
        "Old Status": oldStatus,
        "New Status": newStatus,
        "Current Date": now.toLocaleDateString(),
        "Current Time": time,
      };

      const { leavesAvailable } = this.calculateLeaves(employee);

      switch (newStatus) {
        case "Probation":
          return {
            ...commonValues
          };

        case "Permanent":
          return {
            ...commonValues,
            "New Leaves": employee.newLeaves || leavesAvailable
          };

        case "Resigned":
          return {
            ...commonValues,
            "Approval Date": this.resignationApprovalDate,
            "Notice Period Days": this.noticePeriodDays() - 1,
            "Last Working Date": new Date(
              new Date(this.resignationApprovalDate).setDate(
                new Date(this.resignationApprovalDate).getDate() + (this.noticePeriodDays())
              )
            ).toLocaleDateString('en-GB')
          };

        case "Terminated":
          const termDate = this.terminationDate || this.getTodayDate();
          const formattedTermDate = new Date(termDate).toLocaleDateString('en-GB');
          return {
            ...commonValues,
            "Current Date": formattedTermDate,         
            "Termination Date": formattedTermDate,
            "Last Working Date": formattedTermDate
          };

        default:
          return commonValues;
      }
    },
    calculateLeaves(item) {
      const leavesPerSemester = 7.5;
      const monthsPerSemester = 6;

      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();

      const isSecondSemester = currentMonth >= 6;
      const monthsRemaining = isSecondSemester
        ? 12 - currentMonth
        : 6 - currentMonth;

      const leavesPerMonth = leavesPerSemester / monthsPerSemester;

      const roundToHalf = (num) => Math.round(num * 2) / 2;

      const leavesAllowed = roundToHalf(
        leavesPerMonth * monthsRemaining
      );

      const leavesAvailable = isSecondSemester
        ? leavesAllowed 
        : leavesAllowed + leavesPerSemester;

      return {
        leavesAllowed,
        leavesTaken: 0,
        leavesAvailable,
      };
    },
    noticePeriodDays() {
      if (!this.resignationApprovalDate || !this.lastWorkingDate) {
        return 0;
      }
      if (this.newStatus === 'Terminated') {
        return 0;
      }

      return this.calculateDaysDifference(
        this.resignationApprovalDate,
        this.lastWorkingDate
      );
    },
    openStatusChangeModal({ employee, newStatus, oldStatus }) {
      this.selectedEmployee = employee;
      this.oldStatus = oldStatus;
      this.newStatus = newStatus;
      this.isStatusChangeModalOpen = true;

      let statusForTemplate = newStatus;
      if (newStatus === "Resigned") statusForTemplate = "Resignation";
      if (newStatus === "Terminated") statusForTemplate = "Termination";

      this.selectedTemplate = this.templates.find(t =>
        t.title.includes(statusForTemplate)
      );

      if (!this.selectedTemplate) {
        this.subject = "";
        this.emailBody = "";
        return;
      }

      this.preselectAdminsForCC();
    },
    preselectAdminsForCC() {
      const admins = this.$store.state.auth.allUsers
        .filter(user => user.role === "admin")
        .map(user => user.email);

      this.ccRecipients = [...admins];
    },
    saveMeetingOnlyInDB() {
      this.isMeetingConfirmModalOpen = false
    },
    goToGoogleCalendarSettings () {
      this.isMeetingConfirmModalOpen = false
      this.$router.push('/settings')
    },
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear()
      return `${day}/${month}/${year}`
    },
    async openMeetingModal(user, type) {
      const isConnected = await isGoogleCalendarConnected()
      console.log("Google Calendar connection status:", isConnected);

      if (!isConnected) {
        const choice = await swal({
          title: 'Google Calendar not connected',
          text: 'Do you want to connect Google Calendar or save meeting without syncing?',
          icon: 'warning',
          buttons: {
            connect: {
              text: 'Connect & Sync',
              value: 'connect',
              className: 'swal-btn-connect'
            },
            save: {
              text: 'Save Without Sync',
              value: 'save',
              className: 'swal-btn-save'
            }
          }
        })

        if (choice === 'connect') {
          this.$router.push('/settings')
          return
        }

        if (choice === 'save') {
          this.selectedUser = user
          this.meetingType = type
          this.selectedMeeting = user
          this.showModal = true
          return
        }

        return
      }
      this.selectedUser = user
      this.meetingType = type
      this.selectedMeeting = user
      this.showModal = true
    },
    async saveMeeting(form) {
      try {
        this.loadings.saveMeeting = true
        const dateTime = new Date(`${form.date}T${form.time}`)
        const start = new Date(dateTime)
        const end = new Date(start.getTime() + 30 * 60000)

        const event = {
          summary: form.title,
          description: form.description,
          start: { dateTime: start.toISOString() },
          end: { dateTime: end.toISOString() },
          attendees: form.attendees.map(email => ({ email })),
        }

        let result

        if (await isGoogleCalendarConnected()) {
          if (form.googleEventId) {
            result = await updateMeeting(form.googleEventId, event)
          } else {
            result = await createMeeting(event)
          }
        }
        const meetingObj = {
          type: this.meetingType,
          ...(result && { googleEventId: result.eventId || form.googleEventId }),
          date: form.date,
          time: form.time,
          title: form.title,
          attendees: form.attendees,
          description: form.description,
        }

        if (this.meetingType === 'quarterly') {
          await firebase.createOrUpdateQuarterlyMeetingDetails({
            ...meetingObj,
          }, this.selectedUser.uid)
        } else {
          await firebase.createOrUpdateIncrementMeetingDetails({
            ...meetingObj,
          }, this.selectedUser.uid)
        }

        await this.trackActivity('Save', this.meetingType, this.selectedUser, meetingObj)

        swal("Success", `Meeting ${form.googleEventId ? 'updated' : 'scheduled'} successfully`, "success").then(() => {
          this.showModal = false
        })

      } catch (error) {
        console.error("Error saving meeting:", error)
        swal("Error", "Failed to save meeting. Please try again.", "error")
      } finally {
        this.loadings.saveMeeting = false
      }
    },
    async deleteMeeting() {
      try {
        this.loadings.deleteMeeting = true
        let eventId = "";
        let date = "";
        let time = "";
        let attendees = [];
        const isConnected = await isGoogleCalendarConnected()
        if (this.meetingType === 'quarterly') {
          eventId = this.selectedUser.nextQuarterlyMeetingDetails.googleEventId
          date = this.selectedUser.nextQuarterlyMeetingDetails.date
          time = this.selectedUser.nextQuarterlyMeetingDetails.time
          attendees = this.selectedUser.nextQuarterlyMeetingDetails.attendees || []
          if (isConnected && eventId) {
            await deleteUserMeeting(eventId)
          }
          await firebase.deleteQuarterlyMeetingDetails(this.selectedUser.uid)
        } else {
          eventId = this.selectedUser.nextIncrementMeetingDetails.googleEventId
          date = this.selectedUser.nextIncrementMeetingDetails.date
          time = this.selectedUser.nextIncrementMeetingDetails.time
          attendees = this.selectedUser.nextIncrementMeetingDetails.attendees || []
          if (isConnected && eventId) {
            await deleteUserMeeting(eventId)
          }
          await firebase.deleteIncrementMeetingDetails(this.selectedUser.uid)
        }

        await this.trackActivity('Delete', this.meetingType, this.selectedUser, { date, time, attendees })

        swal("Success", "Meeting deleted successfully", "success")
        .then(() => {
          this.showModal = false
        })
      } catch (error) {
        console.error("Error deleting meeting:", error)
        swal("Error", "Failed to delete meeting. Please try again.", "error") 
      } finally {
        this.loadings.deleteMeeting = false
      }
    },
    async trackActivity(action, type, details, meetingObj) {
      const { username, email, uid } = details;
      let { date, time, attendees } = meetingObj || {};
      date = new Date(`${date}T${time}`).toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      })
      console.log(date)
      console.log(time)
      time = time && (() => {
          const [hourStr, minute] = time.split(':');
          let hour = parseInt(hourStr, 10);
          const ampm = hour >= 12 ? 'PM' : 'AM';
          hour = hour % 12 || 12;
          return `${hour}:${minute} ${ampm}`;
        })();
        console.log(time)
      let title = "";
      let description = "";

      if (action === "Save") {
        title = `${this.currentUser.username} scheduled ${type} meeting for ${username} on ${date} at ${time}`
        description = `${this.currentUser.email} scheduled ${type} meeting for ${email} on ${date} at ${time}.`;

        await logAdminActivity(
          createActivityPayload({
            user: this.currentUser,
            title,
            description,
            username,
            type,
            uid,
            attendees: attendees ? attendees.join(", ") : ""
          })
        );

        const { uid: adminId, username: adminUserName } = this.$store.state.auth.user;
        await handleActivityNotification(
          {
            type,
            activityDescription: description,
            activityOnUser: uid,
            activityOnUserName: username,
            activityByUserName: adminUserName,
            attendees: attendees || [],
          },
          this.$store.state.auth,
          adminId
        );

      } else {
        title = `${this.currentUser.username} deleted ${type} meeting for ${username} on ${date} at ${time}`
        description = `${this.currentUser.email} deleted ${type} meeting for ${email} on ${date} at ${time}.`;

        await logAdminActivity(
          createActivityPayload({
            user: this.currentUser,
            title,
            description,
            username,
            type,
            uid
          })
        );

        const { uid: adminId, username: adminUserName } = this.$store.state.auth.user;
        await handleActivityNotification(
          {
            type,
            activityDescription: description,
            activityOnUser: uid,
            activityOnUserName: username,
            activityByUserName: adminUserName,
            attendees: attendees || [],
          },
          this.$store.state.auth,
          adminId
        );
      }
    },
    onFilterChange(type) {
      this.filterType = type;
    },
    onEmployeeSelect(user) {
      this.selectedEmployee = user;
    },
    onDesignationChange(value) {
      this.designation = value;
      this.grade = ''; // Reset grade when designation changes
    },
    onGradeChange(value) {
      this.grade = value; // Update grade when selected
    },
    onShiftChange(value) {
      this.shift = value;
      this.validateShift();
    },
    validateName() {
      if (!this.name || !this.name.trim().length) {
        this.nameError = "Full name is required";
        return false;
      } else {
        this.nameError = "";
        return true;
      }
    },
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.email || !emailRegex.test(this.email)) {
        this.emailError = "Invalid email format";
        return false;
      } else {
        this.emailError = "";
        return true;
      }
    },
    validateShift() {
      if (!this.shift) {
        this.shiftError = "Shift is required";
        return false;
      } else {
        this.shiftError = "";
        return true;
      }
    },
    validateAllFields() {
      const isNameValid = this.validateName();
      const isEmailValid = this.validateEmail();
      const isShiftValid = this.validateShift();
      return isNameValid && isEmailValid && isShiftValid;
    },
    clearItems: function() {
      this.isEdit = false;
      this.dialog = false;
      this.email = "";
      this.name = "";
      this.designation = "";
      this.grade = "";
      this.editUserId = "";
      this.nameError = "";
      this.emailError = "";
      this.isEmployeeModalOpen = false;
      this.shift = "Morning";
      this.shiftError = "";
    },
    async changeStatus(status, item) {
      try {
        await firebase.updateUserActiveStatus(status, item.uid);
        item.active = status;
        const { uid, username, email } = item;
        let title = "";
        let description = "";

        if (status) {
          title = `${this.currentUser.username} activated ${username}`
          description = `${this.currentUser.email} activated ${email}.`;
          
          await logAdminActivity(
            createActivityPayload({
              user: this.currentUser,
              title,
              description,
              username, 
              type: "update_user", 
              uid
            })
          );

          const { uid: adminId, username: adminUserName } = this.$store.state.auth.user;
          await handleActivityNotification(
            {
              type: "update_user",
              activityDescription: description,
              activityOnUser: uid,
              activityOnUserName: username,
              activityByUserName: adminUserName,
              activityName: title,
            },
            this.$store.state.auth,
            adminId
          );
        } else {
          title = `${this.currentUser.username} deactivated ${username}`
          description = `${this.currentUser.email} deactivated ${email}.`;

          await logAdminActivity(
            createActivityPayload({
              user: this.currentUser,
              title,
              description,
              username, 
              type: "update_user", 
              uid
            })
          );
          const { uid: adminId, username: adminUserName } = this.$store.state.auth.user;
          await handleActivityNotification(
            {
              type: "update_user",
              activityDescription: description,
              activityOnUser: uid,
              activityOnUserName: username,
              activityByUserName: adminUserName,
              activityName: title,
            },
            this.$store.state.auth,
            adminId
          );
        }
        swal("Success", `Employee ${status ? 'activated' : 'deactivated'} successfully`, "success");
      } catch (error) {
        console.error("Error changing status:", error);
        swal("Error", "Failed to update employee status", "error");
      }
    },
    async changeRole(newRole, item) {
      try {
        await firebase.updateUserRole(newRole, item.uid);
        await this.$store.dispatch("fetchAllUsersRealTime");
        const { uid, username, email } = item;
        let title = "";
        let description = "";

        if (newRole === 'admin') {
          title = `${this.currentUser.username} changed ${username}'s role to Admin`
          description = `${this.currentUser.email} changed ${email}'s role to Admin.`;
          
          await logAdminActivity(
            createActivityPayload({
              user: this.currentUser,
              title,
              description,
              username, 
              type: "update_user", 
              uid
            })
          );
          const { uid: adminId, username: adminUserName } = this.$store.state.auth.user;
          await handleActivityNotification(
            {
              type: "update_user",
              activityDescription: description,
              activityOnUser: uid,
              activityOnUserName: username,
              activityByUserName: adminUserName,
              activityName: title,
            },
            this.$store.state.auth,
            adminId
          );
        } else {
          title = `${this.currentUser.username} changed ${username}'s role to User`
          description = `${this.currentUser.email} changed ${email}'s role to User.`;

          await logAdminActivity(
            createActivityPayload({
              user: this.currentUser,
              title,
              description,
              username, 
              type: "update_user", 
              uid
            })
          );

          const { uid: adminId, username: adminUserName } = this.$store.state.auth.user;
          await handleActivityNotification(
            {
              type: "update_user",
              activityDescription: description,
              activityOnUser: uid,
              activityOnUserName: username,
              activityByUserName: adminUserName,
              activityName: title,
            },
            this.$store.state.auth,
            adminId
          );
        }
        swal("Success", `Employee role changed to ${newRole} successfully`, "success");
      } catch (error) {
        console.error("Error changing role:", error);
        swal("Error", "Failed to update employee role", "error");
      }
    },
    loginAsEmployee(employee) {
      if (employee.role === 'admin') {
        swal("Action Not Allowed", "You cannot login as another admin user.", "warning");
        return;
      } else {
        localStorage.setItem('impersonateUser', JSON.stringify(employee));
        localStorage.setItem('originalAdminUser', JSON.stringify(this.currentUser));
        this.employeeLogin(employee);
        this.$root.isImpersonating = true;
        this.$root.impersonatedUser = employee;
        this.$router.push('/overview');
      }
    },
    async employeeLogin(employee) {
      var routeUserId = employee.uid;

      try {
        await this.$store.dispatch('initializeAuth');
        var userData;
        if (routeUserId) {
          userData = await firebase.getSingleUser(routeUserId);
          if (!userData) {
            throw new Error('User not found');
          }
        } else {
          userData = this.$store.state.auth.user || defaultUserData;
        }

        const user = {
          ...userData,
          bankName: userData.bankName || '',
          email: userData.email || '',
          iban: userData.iban || '',
          isActive: userData.isActive !== undefined ? userData.isActive : true,
          joiningDate: userData.joiningDate || '',
          leavesAllowed: userData.leavesAllowed || 7.5,
          leavesAvailable: userData.leavesAvailable || 15,
          leavesTaken: userData.leavesTaken || '',
          nicNumber: userData.nicNumber || '',
          phoneNumber: userData.phoneNumber || '',
          role: userData.role || '',
          salary: userData.salary || 0,
          twitterProfile: userData.twitterProfile || '',
          uid: routeUserId || userData.uid || (this.$store.state.auth.user ? this.$store.state.auth.user.uid : ''),
          username: userData.username || '',
          designation: userData.designation || '',
          grade: userData.grade || '',
          role_title: userData.role_title || '',
          personalEmail: userData.personalEmail || '',
          dateOfBirth: userData.dateOfBirth || '',
          nationality: userData.nationality || '',
          maritalStatus: userData.maritalStatus || '',
          currentAddress: userData.currentAddress || '',
          permanentAddress: userData.permanentAddress || '',
          emergencyContactName: userData.emergencyContactName || '',
          emergencyContactNumber: userData.emergencyContactNumber || '',
          profile_picture: userData.profile_picture || '',
          nicImageUrl: userData.nicImageUrl || '',
          certificateUrl: userData.certificateUrl || '',
          salarySlipUrl: userData.salarySlipUrl || '',
          // company: this.company.companyName,
          fullName: userData.username || '',
          status: userData.status || (this.$store.state.auth.user && this.$store.state.auth.user.status) || 'Active' // Preserve status
        };
        this.$store.commit('setUser', user);

      } catch (error) {
        console.error('Error fetching user from Firebase:', error);
        swal('Error', 'Failed to load user data: ' + error.message, 'error');
        this.user = defaultUserData;
        this.$router.push('/userManagement');
      } finally {
        this.isLoading = false;
      }
    },
    delEmp: function(user) {
      this.selectedUser = user;
      this.isDeleteModalOpen = true;
    },
    confirmDelete: async function() {
      this.isAddingEmployee = true;
      try {
        const response = await fetch(
          `${constants.serverURL}/company/user/delete`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              uid: this.selectedUser.uid,
              email: this.selectedUser.email,
              companyEmail: this.company.email
            })
          }
        );

        const data = await response.json();
        if (response.status !== 200) {
          throw data;
        }
        const { uid, username, email } = this.selectedUser;
        let title = `${this.currentUser.username} deleted the user with name ${username}`;
        let description = `${this.currentUser.email} deleted the user with email ${email}.`;
        
        await logAdminActivity(
          createActivityPayload({
            user: this.currentUser,
            title,
            description,
            username, 
            type: "delete_user", 
            uid
          })
        );
        const { uid: adminId, username: adminUserName } = this.$store.state.auth.user;
        await handleActivityNotification(
          {
            type: "delete_user",
            activityDescription: description,
            activityOnUser: uid,
            activityOnUserName: username,
            activityByUserName: adminUserName,
          },
          this.$store.state.auth,
          adminId
        );
        const company = await firebase.fetchCompanyData(this.$store.state.auth.user.email);
        this.$store.commit("setCompany", company);
        this.isDeleteModalOpen = false;
        this.isAddingEmployee = false;
        swal("User has been deleted", "Deleted", "success");
      } catch (e) {
        this.isAddingEmployee = false;
        console.log("e =>", e);
        swal("Oops!", e.message, "error");
      }
    },
    addPromotion(user) {
      this.selectedPromotionUser = user;
      this.promotionText = "";
      this.isSalaryPromotion = false;
      this.newBasicSalary = null;
      this.newExtraAllowance = null;
      this.promotionEditIndex = null;
      this.isPromotionModalOpen = true;
    },

    togglePromotions(item) {
      this.selectedPromotionUser = item;
      const now = new Date();
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      this.currentSalary = Number(item.basicSalary) + Number(item.extraAllowance);
      this.effectiveDate = `${firstDay.getFullYear()}-${String(firstDay.getMonth() + 1).padStart(2, '0')}-01`;
      this.isNotesModalOpen = true;
      this.selectedEmployee = item
    },


    editPromotion(user, index) {
      const existing = user.promotionInfo[index];
      this.selectedPromotionUser = user;
      this.promotionText = existing.text;
      this.isSalaryPromotion = !!existing.isSalaryPromotion;
      this.newBasicSalary = existing.newBasicSalary || null;
      this.newExtraAllowance = existing.newExtraAllowance || null;
      this.promotionEditIndex = index;
      this.isPromotionModalOpen = true;
    },

    openDeletePromotionModal(index, note) {
      this.promotionToDelete = { index, note };
      this.isDeletePromotionModalOpen = true;
    },

    async confirmDeletePromotion() {
      const { user, index } = this.promotionToDelete;
      try {
        user.promotionInfo.splice(index, 1);
        await this.updatePromotionInDB(user);
        swal("Deleted", "Promotion note removed successfully", "success");
      } catch (error) {
        console.error("Failed to delete promotion note:", error);
        swal("Error", "Failed to delete promotion note", "error");
      } finally {
        this.isDeletePromotionModalOpen = false;
        this.promotionToDelete = null;
      }
    },

    async savePromotion(promotionData) {

      const user = this.selectedPromotionUser;
      if (!user.promotionInfo) user.promotionInfo = [];

      const newPromotion = {
        text: promotionData.text,
        createdAt: new Date().toISOString(),
        isSalaryPromotion: promotionData.type === "increment" ? true : false,
        oldSalary: promotionData.oldSalary,
        newBasicSalary: Number(promotionData.newBasicSalary),
        newExtraAllowance: Number(promotionData.newExtraAllowance),
        increment: promotionData.increment,
        type: promotionData.type,
        percentage: Number(promotionData.percentage),
        effectiveDate: promotionData.effectiveDate
      };

      if (this.promotionEditIndex !== null) {
        user.promotionInfo[this.promotionEditIndex] = newPromotion;
      } else if (promotionData.type === "increment") {
        user.promotionInfo.push(newPromotion);
      } else {
        user.promotionInfo.push({ text: promotionData.text, createdAt: new Date().toISOString(), type: promotionData.type, isSalaryPromotion: false });
      }

      await this.updatePromotionInDB(user);
      this.isPromotionModalOpen = false;
    },

    async updatePromotionInDB(user) {
      try {
        // 1️⃣ Always update promotion info first
        await firebase.updateEmployee({ promotionInfo: user.promotionInfo }, user.uid);

        // 2️⃣ Check if latest promotion is a salary increment
        const lastPromo = user.promotionInfo[user.promotionInfo.length - 1];
        if (lastPromo && lastPromo.isSalaryPromotion) {
          const updatedSalaryData = {
            basicSalary: lastPromo.newBasicSalary,
            extraAllowance: lastPromo.newExtraAllowance
          };

          await firebase.updateEmployee(updatedSalaryData, user.uid);
        }

        // 3️⃣ Refresh data
        await this.$store.dispatch("fetchAllUsersRealTime");

      } catch (error) {
        console.error("Failed to update note:", error);
        swal("Error", "Failed to update note.", "error");
      }
    },

    async updateMeetingDate(user, field, value) {
      try {
        await firebase.updateEmployee({ [field]: value }, user.uid);
        let title = '';
        switch (field) {
          case 'nextQuarterlyMeeting':
            title = 'Next Quarterly Meeting';
            break;
          case 'nextIncrementReview':
            title = 'Next Increment Review';
            break;
          case 'lastWorkingDate':
            title = 'Last Working Date';
            break;
          case 'joiningDate':
          title = 'Joining Date';
          break; 
          default:
            title = 'Meeting Date';
        }
        swal(
          "Updated",
          `${title} updated successfully`,
          "success"
        );
      } catch (error) {
        console.error("Error updating meeting date:", error);
        swal("Error", "Failed to update meeting date", "error");
      }
    },

    calculateDuration(item) {
      const { joiningDate, lastWorkingDate } = item;
      if (!joiningDate) return "-";
      const start = new Date(joiningDate);
      const end = lastWorkingDate ? new Date(lastWorkingDate) : new Date(); // use today if active

      let years = end.getFullYear() - start.getFullYear();
      let months = end.getMonth() - start.getMonth();
      let days = end.getDate() - start.getDate();

      if (days < 0) {
        months -= 1;
        const prevMonth = new Date(end.getFullYear(), end.getMonth(), 0);
        days += prevMonth.getDate();
      }

      if (months < 0) {
        years -= 1;
        months += 12;
      }

      return `${years} years ${months} months ${days} days`;
    },


    addEmp: function() {
      console.log("this.$store.state.auth.company", this.$store.state.auth.company);
      this.isEdit = false;
      this.email = "";
      this.name = "";
      this.designation = "";
      this.grade = "";
      this.isAdmin = false;
      this.nameError = "";
      this.emailError = "";
      this.shift = "Morning";
      this.shiftError = "";
      this.isEmployeeModalOpen = true;
    },
    async addEmployee() { 
      if (!this.validateAllFields()) {
        return;
      }
      this.isLoading = true;

      const email = this.email;
      const name = this.name;
      const designation = this.designation || "";
      const grade = this.grade || "";
      let role = this.isAdmin ? "admin" : "user";
      const joiningDate = new Date().toISOString().split("T")[0];
      const shift = this.shift;
      const nightShiftSettings = shift === "Night" ? {
        specificSettings: true,
        workingDays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        lateTime: "07:00 PM",
        productiveHours: 9
      } : {};
      
      try {
        this.isAddingEmployee = true;
        
        const userEmail = this.$store.state.auth && this.$store.state.auth.user ? 
          this.$store.state.auth.user.email : "";
        if (!userEmail) {
          throw { message: "User email not found" };
        }
        const response = await fetch(`${constants.serverURL}/company/user`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email, name, designation, grade, joiningDate, role,
            companyEmail: userEmail, status: "Probation",
            leavesAllowed: 0, leavesTaken: 0, leavesAvailable: 0,
            shift, ...nightShiftSettings
          })
        }).catch(error => {
          console.error("Fetch error:", error);
          throw new Error(`Failed to connect to server at ${serverURL}. Please ensure the backend server is running and accessible.`);
        });

        const data = await response.json();
        console.log("Backend response:", data); // Log the full response for debugging
        let uid = null;
        if (data && data.user) {
          uid = data.user.uid;
        }
        if (response.status !== 200) {
          throw new Error(data.message || `Failed to add employee (Status: ${response.status})`);
        }
        if (response.status === 200) {
          await this.$store.dispatch("fetchAllUsersRealTime");
          const company = await firebase.fetchCompanyData(this.$store.state.auth.user.email);
          this.$store.commit("setCompany", company);
          
          let title = `${this.currentUser.username} created a new user with name ${name}`;
          let description = `${this.currentUser.email} created a new user with email ${email}.`;

          await logAdminActivity(
            createActivityPayload({
              user: this.currentUser,
              title,
              description,
              username: name, 
              type: "create_user"
            })
          );

          const { uid: adminId, username: adminUserName } = this.$store.state.auth.user;
          await handleActivityNotification(
            {
              type: "create_user",
              activityDescription: description,
              activityOnUser: uid,
              activityOnUserName: name,
              activityByUserName: adminUserName,
              activityName: title,
              role: this.isAdmin ? "admin" : "user"
            },
            this.$store.state.auth,
            adminId
          );

          if (this.isAdmin) {
            title = `${this.currentUser.username} set ${name}'s role as Admin`;
            description = `${this.currentUser.email} set ${email}'s role as Admin.`;
            
            await logAdminActivity(
              createActivityPayload({
                user: this.currentUser,
                title,
                description,
                username: name, 
                type: "create_user"
              })
            );
            // await handleActivityNotification(
            //   {
            //     type: "create_user",
            //     activityDescription: description,
            //     activityOnUser: uid,
            //     activityOnUserName: name,
            //     activityByUserName: adminUserName,
            //     activityName: title,
            //     role: "admin"
            //   },
            //   this.$store.state.auth,
            //   adminId
            // );
          }
        }
        if (this.$store.dispatch) {
          this.$store.dispatch("getAllUsers");
        }
        this.isAddingEmployee = false;
        this.isEmployeeModalOpen = false;
        this.email = "";
        this.designation = "";
        this.grade = "";
        this.name = "";
        this.isAdmin = false;
        this.shift = "Morning";
        this.isLoading = false;
        swal("Great", "Added", "success");
      } catch (e) {
        this.isLoading = false;
        this.isAddingEmployee = false;
        console.error("Error in addEmployee:", e);
        swal("Oops!", e.message || "An error occurred while adding the employee. Please check the input data or server logs.", "error");
      }
    }
  }
};
</script>

<style scoped>

.note-card {
  border: 1px solid #eee;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 10px;
}

.note-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.note-date {
  font-size: 12px;
  color: gray;
}

.delete-icon {
  cursor: pointer;
  color: red;
}

.salary-box {
  border: 1px solid #c8f7c5;
  padding: 10px;
  border-radius: 6px;
  background: #f6fffa;
  margin-top: 10px;
}

.salary-form {
  border: 1px solid #c8f7c5;
  padding: 15px;
  border-radius: 8px;
  background: #f6fffa;
}

.increment-box {
  margin-top: 10px;
  padding: 10px;
  border: 1px solid #c8f7c5;
  border-radius: 6px;
  background: #f6fffa;
}

</style>


// WEBPACK FOOTER //
// src/components/userManagement/AdminUserManagement.vue